import React from 'react';
import {
    FormGroupColumn,
    GroupedRow,
    toasty,
} from '../common/forms/FormElements';
import cls from 'classnames';
import './CrewDisplay.scss';

export default class CrewDisplay extends React.Component {
    getEquipmentType = (equipment) => {
        const { equipmentTypes } = this.props;

        const equipmentType = equipmentTypes.find(
            (et) => equipment.equipmentTypeId == et.id
        );

        return equipmentType.description;
    };

    onCrewEmployeeChanged = (employeeId) => {
        const { job, onCrewComponentsChanged, crew } = this.props;

        let { crewEmployeeMemberships } = job;

        if (crewEmployeeMemberships.includes(employeeId)) {
            crewEmployeeMemberships = crewEmployeeMemberships.filter(
                (cemi) => cemi && cemi != employeeId
            );

            if (crew.crewLeadEmployeeId == employeeId) {
                toasty.warning(
                    'Crew Lead Removed',
                    'Warning - you have deselected the crew lead. If this was correct, please make sure that the Foreman has been updated appropriately.'
                );
            }
        } else {
            crewEmployeeMemberships.push(employeeId);
        }

        onCrewComponentsChanged(crewEmployeeMemberships, null);
    };

    onCrewEquipmentChanged = (equipmentId) => {
        const { job, onCrewComponentsChanged } = this.props;

        let { crewEquipmentMemberships } = job;

        if (crewEquipmentMemberships.includes(equipmentId)) {
            crewEquipmentMemberships = crewEquipmentMemberships.filter(
                (ceqi) => ceqi && ceqi != equipmentId
            );
        } else {
            crewEquipmentMemberships.push(equipmentId);
        }

        onCrewComponentsChanged(null, crewEquipmentMemberships);
    };

    render() {
        const { crew, equipments, employees, onCrewComponentsChanged, job } =
            this.props;

        if (!crew) {
            return null;
        }

        const crewMembers = (employees || []).filter((e) =>
            crew.crewEmployeeMemberships.includes(e.id)
        );

        let crewEmployeeMemberships = null,
            crewEquipmentMemberships = null;

        if (job) {
            crewEmployeeMemberships = job.crewEmployeeMemberships;
            crewEquipmentMemberships = job.crewEquipmentMemberships;
        }

        const editMode =
            onCrewComponentsChanged &&
            crewEmployeeMemberships &&
            crewEquipmentMemberships;

        const crewEquipments = (equipments || []).filter((e) =>
            crew.crewEquipmentMemberships.includes(e.id)
        );

        return (
            <>
                <GroupedRow>
                    <FormGroupColumn>
                        <label className="control-label">Crew Details</label>
                        <div>
                            Crew Name: <strong>{crew.name}</strong>
                        </div>
                    </FormGroupColumn>
                </GroupedRow>

                <GroupedRow>
                    <FormGroupColumn>
                        <label className="control-label">Employees</label>
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Group</th>
                                    {editMode && <th>Selected</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {crewMembers.map((crewMember) => (
                                    <tr
                                        key={`crewMemberTr${crewMember.id}`}
                                        onClick={() =>
                                            this.onCrewEmployeeChanged(
                                                crewMember.id
                                            )
                                        }
                                        className={cls({
                                            'deselected-component':
                                                editMode &&
                                                !job.crewEmployeeMemberships.includes(
                                                    crewMember.id
                                                ),
                                        })}
                                    >
                                        <td>
                                            {crewMember.lastName},{' '}
                                            {crewMember.firstName}
                                            {crew.crewLeadEmployeeId ==
                                                crewMember.id && (
                                                <> (Crew Lead)</>
                                            )}
                                        </td>
                                        <td>
                                            {crewMember.groups
                                                .map((cmg) => cmg.groupName)
                                                .join(', ')}
                                        </td>
                                        {editMode && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={crewEmployeeMemberships.includes(
                                                        crewMember.id
                                                    )}
                                                    readOnly={true}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                ))}

                                {!crewMembers.length && (
                                    <tr>
                                        <td colSpan={2}>
                                            No employees assigned to crew.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </FormGroupColumn>

                    <FormGroupColumn>
                        <label className="control-label">Equipment</label>
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Type</th>
                                    {editMode && <th>Selected</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {crewEquipments.map((crewEquipment) => (
                                    <tr
                                        key={`crewEquipmentTr${crewEquipment.id}`}
                                        onClick={() =>
                                            this.onCrewEquipmentChanged(
                                                crewEquipment.id
                                            )
                                        }
                                        className={cls({
                                            'deselected-component':
                                                editMode &&
                                                !job.crewEquipmentMemberships.includes(
                                                    crewEquipment.id
                                                ),
                                        })}
                                    >
                                        <td>
                                            {crewEquipment.description} (
                                            {crewEquipment.identifier})
                                        </td>
                                        <td>
                                            {this.getEquipmentType(
                                                crewEquipment
                                            )}
                                        </td>
                                        {editMode && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={crewEquipmentMemberships.includes(
                                                        crewEquipment.id
                                                    )}
                                                    readOnly={true}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                ))}

                                {!crewEquipments.length && (
                                    <tr>
                                        <td colSpan={2}>
                                            No equipment assigned to crew.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </FormGroupColumn>
                </GroupedRow>
            </>
        );
    }
}
